var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{on:{"click":function($event){return _vm.login()}}},[_vm._v("Login")]),_c('v-btn',{on:{"click":function($event){return _vm.getPackages()}}},[_vm._v("Packages")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }